module.exports = __webpack_public_path__ + "media/images/team__rangegoatsgc-407f16e92d3f0f40f650fbb46fe474b9.png";